<template>
  <section class="product-gooval" id="gooval-product">
    <div class="section-inner">
      <div class="content-wrapper">
        <div class="text-content">
          <p class="section-label fade-in-section">{{ t('home.gooval.label') }}</p>
          <h2 class="section-title fade-in-section">{{ t('home.gooval.title') }}</h2>
          <p class="section-subtitle fade-in-section">{{ t('home.gooval.subtitle') }}</p>

          <ul class="feature-list">
            <li
              v-for="featureKey in featureKeys"
              :key="featureKey"
              class="feature-item fade-in-section"
            >
              <span class="feature-dot" aria-hidden="true"></span>
              <div>
                <div class="feature-title">{{ t(`home.gooval.features.${featureKey}.title`) }}</div>
                <div class="feature-description">{{ t(`home.gooval.features.${featureKey}.description`) }}</div>
              </div>
            </li>
          </ul>

          <div class="action-row fade-in-section">
            <a
              class="btn btn-primary"
              href="https://apps.shopify.com/gooval-shipping-protection"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ t('home.gooval.shopify') }}
            </a>
            <a
              class="btn btn-secondary"
              href="https://www.gooval.io/docs/open-api#overview"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ t('home.gooval.openApi') }}
            </a>
          </div>
        </div>

        <div class="image-content fade-in-section">
          <img
            :src="productImage"
            :alt="t('home.gooval.title')"
            class="product-image"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { useTranslation } from '@/utils/i18n'

const productImage = require('@/assets/img/home/product-gooval.png')

export default {
  name: 'ProductGooval',
  setup() {
    const { t } = useTranslation()
    const featureKeys = ['feature1', 'feature2', 'feature3', 'feature4']

    return {
      t,
      productImage,
      featureKeys
    }
  }
}
</script>

<style lang="scss" scoped>
.product-gooval {
  padding: 96px 20px;
  background: #ffffff;
}

.section-inner {
  max-width: 1100px;
  margin: 0 auto;
}

.content-wrapper {
  display: grid;
  grid-template-columns: 1.05fr 0.95fr;
  gap: 48px;
  align-items: center;
}

.section-label {
  margin: 0 0 12px;
  font-size: 12px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #1a7fb0;
  font-family: 'Aileron-Bold', sans-serif;
}

.section-title {
  margin: 0 0 16px;
  font-size: clamp(24px, 3vw, 34px);
  line-height: 1.25;
  color: #0b2238;
  font-family: 'Aileron-Bold', sans-serif;
}

.section-subtitle {
  margin: 0 0 28px;
  font-size: 16px;
  line-height: 1.7;
  color: #4a6075;
  font-family: 'Aileron-Regular', sans-serif;
}

.feature-list {
  list-style: none;
  margin: 0 0 32px;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.feature-item {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.feature-dot {
  width: 8px;
  height: 8px;
  margin-top: 8px;
  border-radius: 50%;
  background: #1a7fb0;
  flex-shrink: 0;
}

.feature-title {
  margin-bottom: 4px;
  font-size: 16px;
  color: #0b2238;
  font-family: 'Aileron-Bold', sans-serif;
}

.feature-description {
  font-size: 14px;
  line-height: 1.65;
  color: #52667a;
  font-family: 'Aileron-Regular', sans-serif;
}

.action-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 20px;
  font-size: 14px;
  border-radius: 8px;
  text-decoration: none;
  transition: transform 0.25s ease;
  font-family: 'Aileron-Bold', sans-serif;
}

.btn-primary {
  background: linear-gradient(135deg, #1a7fb0 0%, #0f4c81 100%);
  color: #ffffff;
  box-shadow: 0 8px 20px rgba(15, 76, 129, 0.2);
}

.btn-primary:hover {
  transform: translateY(-2px);
  background: linear-gradient(135deg, #2196c4 0%, #125a94 100%);
  box-shadow: 0 12px 24px rgba(15, 76, 129, 0.28);
}

.btn-secondary {
  background: #eef4f8;
  color: #0f4c81;
  border: 1px solid rgba(15, 76, 129, 0.18);
}

.btn-secondary:hover {
  transform: translateY(-2px);
}

.product-image {
  width: 100%;
  aspect-ratio: 4 / 3;
  object-fit: cover;
  object-position: center;
  border-radius: 12px;
}

@media (max-width: 900px) {
  .content-wrapper {
    grid-template-columns: 1fr;
  }

  .action-row {
    flex-direction: column;
  }

  .btn {
    width: 100%;
  }
}
</style>
